// src/pages/QuotasPage.js
import React from 'react';
import { useParams } from 'react-router-dom';
import QuotasManager from '../components/ui/QuotasManager';

function QuotasPage () {
	const { surveyId } = useParams();

	return (
		<QuotasManager surveyId={surveyId} />
	);
}

export default QuotasPage;